export const testimonials = [
  {
    id: 1,
    name: '张女士',
    location: '北京',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%20headshot%2C%20warm%20cream%20background%2C%20soft%20lighting%2C%20professional%20headshot%20photography&width=100&height=100&seq=avatar-1&orientation=squarish',
    rating: 5,
    content: '在在线黄油买了法兰西发酵黄油，做出来的可颂层次分明，奶香浓郁！客服态度也很好，下单第二天就收到了，冷链包装非常专业。',
    product: '法兰西发酵黄油卷',
    date: '2026-08-08',
  },
  {
    id: 2,
    name: '李先生',
    location: '上海',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20portrait%20headshot%2C%20warm%20cream%20background%2C%20soft%20lighting%2C%20professional%20headshot%20photography&width=100&height=100&seq=avatar-2&orientation=squarish',
    rating: 5,
    content: '作为一名面包店主，这里的黄油品质非常稳定，比利时黄油片的价格很有竞争力。已经复购多次，推荐给了很多同行朋友。',
    product: '比利时发酵黄油片',
    date: '2026-08-03',
  },
  {
    id: 3,
    name: '王小姐',
    location: '广州',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20headshot%2C%20warm%20cream%20background%2C%20soft%20lighting%2C%20professional%20headshot%20photography&width=100&height=100&seq=avatar-3&orientation=squarish',
    rating: 5,
    content: '第一次尝试有机黄油，丹麦Lurpak的口感真的惊艳到我了！做出来的曲奇饼干特别香，家里人都说比外面买的好吃。',
    product: '丹麦有机发酵黄油',
    date: '2026-07-29',
  },
  {
    id: 4,
    name: '赵先生',
    location: '成都',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20man%20portrait%20headshot%2C%20warm%20cream%20background%2C%20soft%20lighting%2C%20professional%20headshot%20photography&width=100&height=100&seq=avatar-4&orientation=squarish',
    rating: 4,
    content: '新西兰无盐黄油性价比很高，家庭日常烘焙完全够用。物流也很快，成都下单隔天就到了，会继续支持。',
    product: '新西兰无盐动物黄油',
    date: '2026-07-22',
  },
];

export const brandMilestones = [
  { year: '2018', title: '品牌创立', description: '在线黄油品牌正式创立，致力于为中国消费者提供优质黄油产品。' },
  { year: '2019', title: '建立供应链', description: '与法国、新西兰、丹麦等优质产区的黄油品牌建立直供合作关系。' },
  { year: '2020', title: '线上平台上线', description: '官方网站和移动端上线，开启全国冷链配送服务。' },
  { year: '2021', title: '用户突破10万', description: '凭借优质产品和贴心服务，累计服务用户突破10万人次。' },
  { year: '2022', title: '品类全面拓展', description: '新增有机黄油、草饲黄油等品类，产品SKU超过50种。' },
  { year: '2023', title: '自有冷链体系', description: '建立覆盖全国30+城市的自有冷链物流体系，确保产品新鲜送达。' },
  { year: '2024', title: '品质升级', description: '引入AI智能品控系统，每一批黄油都经过严格质量检测。' },
  { year: '2025', title: '行业领军', description: '年销售额突破亿元，成为国内黄油垂直电商领域领军品牌。' },
];